export const CHECK_RESULT_RATING_MAIL_FAILURE = 'CHECK_RESULT_RATING_MAIL_FAILURE';

export const checkResultRatingMailFailure = error => ({
    type: CHECK_RESULT_RATING_MAIL_FAILURE,
    payload: error,
    error: true,
});
